import React from 'react';
import SharedCardType from '@src/pages/ticketShared/cardOrders/cardInformation/CardType';
import CardDigital from '@src/assets/icons/img-dijital-kart2.webp';
import img_fiziksel_kart2 from '@src/assets/icons/img_fiziksel_kart2.png';
import { VouIdCode } from '@src/store/enums';

const Wrapper = (props) => (
  <SharedCardType
    vouId={VouIdCode.Compliments}
    CardDigitalSrc={CardDigital}
    fizikselImgSrc={img_fiziksel_kart2}
    bankCardLogoClass1={{ className: 'bank-card-logo', src: undefined }}
    bankCardLogoClass2={'bank-card-logo2'}
    {...props}
  />
);

export default Wrapper;
